import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id A39CC0FD-32DA-4AB2-8483-9E4C4F03D220
 * name lamp
 * version: 1.7.22
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lamp.svg
 * tags
 * - Home Automation 
 */
export const LampIcon = createSvgIcon(<><path d="M8,2H16L20,14H4L8,2M11,15H13V20H18V22H6V20H11V15Z" /></>, 'LampIcon');
export default LampIcon